import { Box } from '@mui/material';
import LoadingSpinner from '../commonUI/LoadingSpinner';

interface LoadingSpinnerWrapperProps {
  isLoading?: boolean;
}

const LoadingSpinnerWrapper: React.FC<LoadingSpinnerWrapperProps> = ({
  isLoading = false,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '2.1rem',
      height: '100%',
    }}
  >
    {isLoading && <LoadingSpinner size='1.2rem' />}
  </Box>
);

export default LoadingSpinnerWrapper;
